import * as ReactDOM from 'react-dom/client';
import createAppRoot from './main';
import { routerConfig } from './app/routes';
import { Router } from 'wouter';
import initSentry from './app/sentry/sentry-client';
import { initMixpanel } from './app/analytics/mixpanel';
import { initHotjar } from './app/analytics/hotjar';
import { createHead } from '@unhead/react/client';

initMixpanel();

if (import.meta.env.VITE_ANALYTICS_ENABLED === 'true') {
  initHotjar();
}

if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  initSentry();
}

const head = createHead();

// We only hydrate outside of local dev. In local dev pages are served _without_ SSR via
// the default Vite dev server, whereas in production we serve statically built pages
// that are then replaced with the client version.
if (import.meta.env.MODE === 'development') {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLDivElement);
  root.render(<Router>{createAppRoot(routerConfig, head)}</Router>);
} else {
  ReactDOM.hydrateRoot(
    document.getElementById('root') as HTMLDivElement,
    <Router>{createAppRoot(routerConfig, head)}</Router>,
  );
}
